import { Button, Group, Modal, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { toDateInputValue, toExpirationTimestamp } from "../../utils/dates";
import ExpirationQuickSet from "./ExpirationQuickSet";

interface BulkRenewModalProps {
	opened: boolean;
	count: number;
	loading: boolean;
	onClose: () => void;
	onSubmit: (expirationDate: string) => void;
}

function BulkRenewModal({
	opened,
	count,
	loading,
	onClose,
	onSubmit,
}: BulkRenewModalProps) {
	const form = useForm({
		initialValues: {
			expirationDate: toDateInputValue(new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)),
		},
		validate: {
			expirationDate: (value) => {
				if (!value) return "Expiration date is required";
				return new Date(toExpirationTimestamp(value)) <= new Date()
					? "Expiration date must be in the future"
					: null;
			},
		},
	});

	useEffect(() => {
		if (opened) {
			form.reset();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [opened]);

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title="Renew Licenses"
			size="md">
			<form
				onSubmit={form.onSubmit((values) => onSubmit(values.expirationDate))}>
				<Stack gap="md">
					<Text>
						Set a new expiration date for {count} selected license(s). Revoked
						and unlimited licenses will be skipped.
					</Text>

					<Stack gap="xs">
						<TextInput
							label="Expiration Date"
							type="date"
							required
							{...form.getInputProps("expirationDate")}
						/>
						<ExpirationQuickSet
							onSelect={(date) => form.setFieldValue("expirationDate", date)}
						/>
					</Stack>

					<Group
						justify="flex-end"
						mt="lg">
						<Button
							variant="light"
							onClick={onClose}>
							Cancel
						</Button>
						<Button
							type="submit"
							loading={loading}>
							Renew
						</Button>
					</Group>
				</Stack>
			</form>
		</Modal>
	);
}

export default BulkRenewModal;
